import { getCookieByName } from '~/utilities/data/getCookieByName';
import { readPublisherConsentCookie } from '~/utilities/data/readPublishConsentCookie';
import { getAnalyticsConsent } from '~/utilities/data/getAnalyticsConsent';
import { getGdprApplies } from '~/utilities/data/getGdprApplies';
import { Logger } from '~/utilities/logger';

/**
 * Retrieves and constructs page data with various consent and session information.
 *
 * @param {Function} eventName - A callback function to process the pageData.
 * @returns {any} - The result of the eventName callback function, passing in the constructed pageData.
 *
 * This function aggregates data related to user consents and session information from different utilities and cookies:
 * - Fetches page-specific data from the client API.
 * - Retrieves analytics consent status using the publisher consent cookie.
 * - Checks if GDPR applies.
 * - Extracts user ID and session ID from cookies.
 *
 * The aggregated data is then passed to the provided eventName callback function.
 */
export const getPageData = (eventName: any): any => {
  let pageData;
  const data = {
    ...window.clientApiData?.pageData,
    analyticsConsent: getAnalyticsConsent(readPublisherConsentCookie()),
    gdprApplies: getGdprApplies(),
    mmcookieUserID: getCookieByName('mm-user-id'),
    sessionId: getCookieByName('mm-session-id'),
  };

  try {
    pageData = eventName(data);
  } catch (error) {
    new Logger().error({
      message: 'Error in getPageData',
      error,
    });
  }

  return pageData;
};
